/*
    Vue
*/
import Vue from 'vue';

/*
    Packages
*/
import VueTranslate from 'vue-translate-plugin';
import Notifications from 'vue-notification';
import VTooltip from 'v-tooltip';
import VueDragDrop from 'vue-drag-drop';

/*
    Components / Local files
*/
import App from './App';
import router from './router';
import Locales from './locales/locales';
import Auth from './classes/Auth';
import keys from './keys';
import OnlineShopConnectorApiSDK from './classes/API/API';
import { getToken, getUser } from './helpers/auth';

/*
    Config
*/
Vue.config.productionTip = false;

/*
    Plugins
*/
Vue.use(VueTranslate);
Vue.use(Notifications);
Vue.use(VTooltip);
Vue.use(VueDragDrop);

/*
    Global variables
*/
Vue.prototype.$logo = 'XMLShopconnector';
Vue.prototype.$http = new Auth(`${keys.API_URL}/api/auth/login`, '/login', '/', `${keys.API_URL}/api/auth/me`);
Vue.prototype.$API_URL = keys.API_URL;
Vue.prototype.$FRONTEND_URL = keys.FRONTEND_URL;
Vue.prototype.API = new OnlineShopConnectorApiSDK(`${keys.API_URL}/api`, 'nl_NL', getToken());

/*
    Directives
*/
Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    },
});

let handleOutsideClick;

Vue.directive('closable', {
    bind(el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
            e.stopPropagation();
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value;

            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false;
            exclude.forEach(refName => {
                // We only run this code if we haven't detected
                // any excluded element yet
                if (!clickedOnExcludedEl) {
                    // Get the element using the reference name
                    const excludedEl = vnode.context.$refs[refName];
                    // See if this excluded element
                    // is the same element the user just clicked on
                    clickedOnExcludedEl = excludedEl.contains(e.target);
                }
            });

            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                // If the clicked element is outside the dialog
                // and not the button, then call the outside-click handler
                // from the same component this directive is used in
                vnode.context[handler]();
            }
        };
        // Register click/touchstart event listeners on the whole page
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);
    },

    unbind() {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('touchstart', handleOutsideClick);
    },
});

new Vue({
    router,
    render: h => h(App),
    mounted() {
        const user = getUser();

        if (user !== null) {
            if (user.language !== null) {
                this.$translate.setLang(user.language);
            } else {
                this.$translate.setLang('nl_NL');
            }
        } else {
            this.$translate.setLang('nl_NL');
        }
    },
    locales: Locales,
}).$mount('#app');
